// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".processingCircle[data-v-cc0f1e9a] span {\n  border-radius: 50%;\n}", ""]);
// Exports
module.exports = exports;
